import { Role } from '@contrast-security-inc/base-types'
import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'
import { AgentLanguageValue } from '../../../agent-language/agent-language'

export interface Application {
  language: AgentLanguageValue
  name: string
  primary: boolean
  roles: Role[]
}

interface ApplicationApiResponse extends BaseApiResponse {
  application: Application
}

export interface GetApplicationArgs {
  organizationUuid: string
  applicationId: string
}

export async function getApplication(
  this: ThisConnector,
  { organizationUuid, applicationId }: GetApplicationArgs
): Promise<Application> {
  const { application } = await this.connector.get<ApplicationApiResponse>(
    `/${organizationUuid}/applications/${applicationId}`
  )
  return application
}
